import React, { PropsWithChildren } from 'react'
import { IconType } from 'react-icons'
import { Icon, IconProps } from '@chakra-ui/icons'
import { Text } from '@chakra-ui/react'
import {
    MenuItem as ChakraMenuItem,
    type MenuItemProps as ChakraMenuItemProps,
} from '@chakra-ui/react'

export interface MenuItemProps extends Omit<ChakraMenuItemProps, 'icon'> {
    icon?: IconType
    iconProps?: IconProps
}

export default function MenuItem({
    children,
    onClick,
    icon,
    iconProps,
    ...rest
}: PropsWithChildren<MenuItemProps>) {
    return (
        <ChakraMenuItem
            onClick={onClick}
            icon={icon && <Icon as={icon} fontSize="md" {...iconProps} />}
            px={4}
            bg="transparent"
            _hover={{
                bg: 'gray.50',
            }}
            _active={{
                bg: 'gray.100',
            }}
            fontSize="xs"
            fontWeight="medium"
            {...rest}
        >
            <Text>{children}</Text>
        </ChakraMenuItem>
    )
}
